const PLAN_TEMP_TABLE_FALLBACK_REGEX =
  /\b(?:fg_plan_[a-z0-9_]+|__fg_(?:agg|aggp|dense|fxlod|mpiv|page|pageagg|totals|winp)_[a-z0-9_]+(?:__q\d+)?)\b/i
const EXECUTION_SCOPED_WORKING_SET_REGEX = /\b__fg_ws_(?:base|context)_[a-z0-9_]+\b/i
const EXECUTION_SCOPED_FILTER_TEMP_TABLE_REGEX = /\b__fg_ft_[a-z0-9_]+_\d+\b/i

export const collectPlanTempTableNamesFromStatements = (statementsRaw: any): string[] => {
  const statements = Array.isArray(statementsRaw) ? statementsRaw : []
  const out: string[] = []
  for (const stmtRaw of statements) {
    const stmt = String(stmtRaw ?? '').trim()
    const match = stmt.match(
      /^create\s+(?:(?:or\s+replace)\s+)?(?:temp|temporary)\s+(?:table|view)\s+(?:if\s+not\s+exists\s+)?([^\s(]+)\s+/i,
    )
    const ident = String(match?.[1] ?? '').trim().replace(/^["`]|["`]$/g, '')
    if (ident && !out.includes(ident)) out.push(ident)
  }
  return out
}

export const collectReferencedPlanTempTableNamesFromSql = (sqlRaw: string): string[] => {
  const sqlText = String(sqlRaw || '').trim()
  if (!sqlText) return []
  return Array.from(new Set(
    (
      sqlText.match(
        /\b(?:fg_plan_[a-z0-9_]+(?:__q\d+)?|__fg_(?:agg|aggp|dense|fxlod|mpiv|page|pageagg|totals|winp)_[a-z0-9_]+(?:__q\d+)?)\b/gi,
      ) || []
    )
      .map((name) => String(name || '').trim())
      .filter(Boolean),
  ))
}

export const sqlHasUnboundPlanTempTableDependencies = (
  sqlRaw: string,
  statementsRaw: any,
): boolean => {
  const referenced = collectReferencedPlanTempTableNamesFromSql(sqlRaw)
  if (referenced.length <= 0) return false
  const provided = new Set(
    collectPlanTempTableNamesFromStatements(statementsRaw)
      .map((name) => String(name || '').trim().toLowerCase())
      .filter(Boolean),
  )
  if (provided.size <= 0) return true
  return referenced.some((name) => !provided.has(String(name || '').trim().toLowerCase()))
}

export const sqlDependsOnPlanTempTables = (
  sqlRaw: string,
  statementsRaw: any,
): boolean => {
  const sqlText = String(sqlRaw || '').trim()
  if (!sqlText) return false
  const escapeRegex = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  if (
    collectPlanTempTableNamesFromStatements(statementsRaw).some((tableName) => {
      const barePattern = new RegExp(`(?<![A-Za-z0-9_])${escapeRegex(tableName)}(?![A-Za-z0-9_])`, 'i')
      const quotedPattern = new RegExp(escapeRegex(`"${tableName.replace(/"/g, '""')}"`), 'i')
      return barePattern.test(sqlText) || quotedPattern.test(sqlText)
    })
  ) {
    return true
  }
  return PLAN_TEMP_TABLE_FALLBACK_REGEX.test(sqlText)
}

export const sqlDependsOnExecutionScopedWorkingSetTables = (
  sqlRaw: string,
): boolean => {
  const sqlText = String(sqlRaw || '').trim()
  if (!sqlText) return false
  return (
    EXECUTION_SCOPED_WORKING_SET_REGEX.test(sqlText) ||
    EXECUTION_SCOPED_FILTER_TEMP_TABLE_REGEX.test(sqlText)
  )
}
